var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulkuploadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 62,
    viewBox: "0 0 96 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5142 11.5499C36.6382 5.17756 43.8119 0.953125 51.9773 0.953125C64.2873 0.953125 74.3549 10.5541 75.1006 22.6764C75.3463 22.667 75.5931 22.6623 75.8409 22.6623C86.4394 22.6623 95.0312 31.2541 95.0312 41.8527C95.0312 52.4512 86.4394 61.043 75.8409 61.043L26.125 61.043C12.2316 61.043 0.96875 49.7802 0.96875 35.8868C0.96875 21.9933 12.2316 10.7305 26.125 10.7305C28.3296 10.7305 30.4715 11.0149 32.5142 11.5499ZM61.4996 34.2327C60.3675 35.6478 58.3027 35.8772 56.8876 34.7452L51.2812 30.2601V45.3079C51.2812 47.1201 49.8122 48.5892 48 48.5892C46.1878 48.5892 44.7187 47.1201 44.7187 45.3079V30.2599L39.1121 34.7452C37.6971 35.8772 35.6322 35.6478 34.5001 34.2327C33.3681 32.8176 33.5975 30.7528 35.0126 29.6207L45.9384 20.8801C46.4951 20.4299 47.2021 20.1582 47.9723 20.1518L48 20.1517L48.0106 20.1517C48.7942 20.1542 49.5131 20.4313 50.0762 20.8919L60.9871 29.6207C62.4022 30.7528 62.6316 32.8176 61.4996 34.2327Z",
    fill: "#D4DBE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkuploadIcon);
export default __webpack_public_path__ + "static/media/bulkuploadIcon.fd7222691afbf95202d2116455d2263c.svg";
export { ForwardRef as ReactComponent };